module.exports = __webpack_public_path__ + "static/media/deleteExternalCall.07d64fd4.svg";